<template>
    <span
        v-b-tooltip.hover
        class="treatment-start-date"
        :title="$translate('treatment_start_date')"
    >
        {{ formattedDate }}
    </span>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
    name: 'TreatmentStartDate',
    props: {
        date: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapState({
            locale: state => state.locale.locale
        }),
        formattedDate() {
            moment.locale(this.locale.code)
            const momentDate = moment(this.date)

            if (momentDate.isValid()) {
                return momentDate.format('MMM DD, YYYY')
            }
            return this.date
        }
    }
}
</script>

<style lang="scss" scoped>
.treatment-start-date {
    font-size: 10pt;
    color: $light-3;
    white-space: nowrap;
}
</style>
